/**
 * 어플리케이션에서 사용하는 여러 상수들을 정의한 파일입니다.
 */

/**
 * 업로드 할 파일 하나에 대한 사이즈 MAX를 나타내는 상수 입니다.
 */
export const FILE_SINGLE_SIZE_MAX_LIMIT = 10 * 1024 * 1024; // 10MB

/**
 * 업로드 할 파일의 총 사이즈 MAX를 나타내는 상수 입니다.
 */
export const FILE_TOTAL_SIZE_MAX_LIMIT = 10 * 1024 * 1024; // 10MB

/**
 * 업로드할 파일 중 실행파일을 체크하는 정규식입니다.
 */
export const FILE_EXE_EXT_REGEX =
  /(bat|bin|cmd|com|cpl|dll|exe|gadget|inf1|ins|isu|jse|lnk|msc|msi|msp|mst|paf|pif|ps1|reg|rgs|scr|sct|sh|shb|shs|u3p|vb|vbe|vbs|vbscript|ws|wsf|wsh)$/i;
